import { render, staticRenderFns } from "./LearningItemView.vue?vue&type=template&id=327f0c7e&scoped=true&"
import script from "./LearningItemView.vue?vue&type=script&lang=js&"
export * from "./LearningItemView.vue?vue&type=script&lang=js&"
import style0 from "./LearningItemView.vue?vue&type=style&index=0&id=327f0c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f0c7e",
  null
  
)

export default component.exports